module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_datarepup_m.0e16ed2cdaf7b4f1ca570fdedf101b40.png";